<template>
  <section class="section">
    <div class="container">
      <h1 class="title" v-if="reportProcessing">Report Loading ...</h1>
      <h1 class="title" v-if="processingFailure">Report processing failed!</h1>
      <ReportSummary
        v-if="reportReady"
        :reportSummary="reportSummary"
        :driveTimeUnitOfMeasure="getDriveTimeUnitOfMeasure"
      />
      <table
        class="table is-bordered is-hoverable is-fullwidth"
        v-if="reportReady"
      >
        <thead>
          <tr>
            <th>Date</th>
            <th>Start Location</th>
            <th>End Location</th>
            <th>Mileage</th>
            <th>Drive Time</th>
            <th>Mileage Reimbursement Amount</th>
          </tr>
        </thead>
        <tfoot>
          <tr>
            <th>Total</th>
            <td></td>
            <td></td>
            <td>{{ reportSummary.totalMileage }} mi</td>
            <td>
              {{ reportSummary.totalDriveTime }}
              {{ getDriveTimeUnitOfMeasure }}
            </td>
            <td>${{ reportSummary.totalReimbursement }}</td>
          </tr>
        </tfoot>
        <tbody>
          <tr v-for="mileageRecord in mileageRecords" :key="mileageRecord.id" v-bind:class="reportHasError(mileageRecord.mileage)">
            <th>{{ mileageRecord.date }}</th>
            <td>
              {{ mileageRecord.start_location }} ({{
                mileageRecord.start_location_client
              }})
            </td>
            <td>
              {{ mileageRecord.end_location }} ({{
                mileageRecord.end_location_client
              }})
            </td>
            <td>{{ mileageRecord.mileage }}</td>
            <td>{{ mileageRecord.drive_time }}</td>
            <td>${{ mileageRecord.reimbursement }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import ReportSummary from "@/components/ReportSummary.vue";

export default {
  props: {
    reportName: {
      type: String,
      default: "",
      required: true,
    },
    account: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  components: {
    ReportSummary,
  },
  data() {
    return {
      reportProcessing: true,
      processingFailure: false,
      reportReady: false,
      mileageRecords: "",
      pollInterval: null,
      timeoutVal: null,
      reportSummary: {
        fullName: "",
        dateRange: "",
        reportGeneratedOn: "",
        reportGeneratedBy: "",
        totalDriveTime: "",
        totalMileage: "",
        totalReimbursement: "",
      },
    };
  },
  computed: {
    getDriveTimeUnitOfMeasure: function() {
      if (this.account) {
        return this.account.approved_products.milelogix_for_teams
          ? "hours"
          : "minutes";
      }
      return "minutes";
    },
  },
  methods: {
    getReport: function() {
      this.$http
        .get(process.env.VUE_APP_API_URL + "/report/" + this.reportName)
        .then((httpResponse) => {
          if (httpResponse.data.mileage_records) {
            clearInterval(this.pollInterval);
            clearTimeout(this.timeoutVal);
            this.mileageRecords = httpResponse.data.mileage_records;
            this.reportProcessing = false;
            this.reportReady = true;
            this.processingFailure = false;
            this.reportSummary.fullName = httpResponse.data.calendar_name;
            this.reportSummary.dateRange =
              httpResponse.data.start_date + " - " + httpResponse.data.end_date;
            this.reportSummary.reportGeneratedOn =
              httpResponse.data.generated_date;
            this.reportSummary.totalDriveTime =
              httpResponse.data.total_drive_time;
            this.reportSummary.totalMileage = httpResponse.data.total_mileage;
            this.reportSummary.totalReimbursement =
              httpResponse.data.total_reimbursement;
            this.reportSummary.reportGeneratedBy =
              httpResponse.data.generated_by;
          }
        })
        .catch(function() {
          this.reportProcessing = false;
          this.reportReady = false;
          this.processingFailure = true;
        });
    },
    reportHasError: function(mileage) {
      return mileage === "" ? "is-selected" : "";
    },
  },
  mounted() {
    this.getReport();
    if (!this.reportReady) {
      this.pollInterval = setInterval(
        this.getReport,
        process.env.VUE_APP_REPORTDISPLAY_REFRESH
      ); //Retry request in seconds
      this.timeoutVal = setTimeout(() => {
        clearInterval(this.pollInterval);
        this.reportProcessing = false;
        this.processingFailure = true;
      }, process.env.VUE_APP_REPORTDISPLAY_TIMEOUT); //Cancel retry after timeout in seconds and set report processing error state to true
    }
  },
};
</script>

<style scoped>
.table tr.is-selected {
  background-color: crimson;
}
</style>
